import React, { useContext } from 'react';
import { Industries } from './Industries';

export const IndustriesContext = React.createContext({
    industries: new Industries([]),
});
export function useIndustriesContext() {
    return useContext(IndustriesContext).industries;
}
